<template>
  <v-app-bar
    :app="app"
    color="primary"
    dark
    clipped-left
    clipped-right
  >
    <v-icon class="mr-3" x-large>mdi-truck-fast</v-icon>
    <h1>ProDelivery</h1>
    <InfoBlock v-if="Object.keys(sysInfo).length && $vuetify.breakpoint.mdAndUp">
      <span>sys: {{ sysInfo.version }}</span>
      <span>dbv: v1</span>
      <span>rkv: {{ ping.mid_version }}</span>
    </InfoBlock>
    <InfoBlock v-if="Object.keys(sysInfo).length && $vuetify.breakpoint.smAndUp">
      <span>lic: {{ licenseStatus }}</span>
      <span>exp: <DateSpan :date="exp"/></span>
      <!-- <span>xml: <DateSpan :date="new Date()"/></span> -->
    </InfoBlock>
    <!-- TODO: проверка лицензий -->
    <v-btn test-tag="tag-69" v-if="actions & $vuetify.breakpoint.mdAndUp" icon class="ml-3" style="opacity: .7" @click="$store.dispatch('loadSystemInfo')"><v-icon>mdi-reload</v-icon></v-btn>
    <v-spacer></v-spacer>
    <!-- <InfoBlock v-if="$store.getters.user.mode !== 'ADMINISTRATOR' && $vuetify.breakpoint.smAndUp">
      <v-btn test-tag="tag-70" small tile :color="status? 'success': 'error'" 
        @click.stop="check_connection">
        r_keeper {{ status ? 'OK' : 'ERROR'}}
      </v-btn>
    </InfoBlock> -->
    <InfoBlock v-if="actions & $vuetify.breakpoint.smAndUp">
      <span>{{$store.getters.user.fullname}}</span>
      <span>{{$store.getters.user.mode}}</span>
    </InfoBlock>

    <v-btn test-tag="tag-71" icon class="ml-3" @click="$store.dispatch('logout')"><v-icon>mdi-logout</v-icon></v-btn>
  </v-app-bar>
</template>

<script>
import InfoBlock from './InfoBlock.vue'
import DateSpan from './DateSpan.vue'
import { mapGetters } from 'vuex';

export default {
  props:{
    app: {
      type: Boolean,
      default: true
    },
    versions: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    status: true
  }),
  computed: {
    ...mapGetters(['ping', 'sysInfo']),
    licenseStatus() {
      return this.sysInfo.license.status ? 'ok' : 'error'
    },
    exp() {
      const [day, month, year] = this.sysInfo.license.expires.split('.')
      return new Date(year, month - 1, day)
    },
  },
  methods:{
    async check_connection(){
      try {
        await this.$store.dispatch('globalPing')
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${this.$t('Соединение установлено!')}}`,
          message_class: 'success'
        })
        this.status = true
      } catch (e) {
        this.status = false
      }
    }
  },
  async mounted(){
    await this.$store.dispatch('loadSystemInfo')
    await this.$store.dispatch('globalPing')
  },
  components:{
    InfoBlock,
    DateSpan
  }
}
</script>